/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IEnqueue, IEnqueueInterface } from "../IEnqueue";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "enqueue",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

export class IEnqueue__factory {
  static readonly abi = _abi;
  static createInterface(): IEnqueueInterface {
    return new utils.Interface(_abi) as IEnqueueInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IEnqueue {
    return new Contract(address, _abi, signerOrProvider) as IEnqueue;
  }
}
